import GlobalUtils from '@/lib/utils/global-utils';

export const debounce = () => {
  let h: number;
  return (func: () => void, wait = 50) => {
    window.clearTimeout(h);
    h = window.setTimeout(() => func(), wait);
  };
};

export const clone = object => {
  if (typeof object === 'undefined') {
    return {};
  }
  return JSON.parse(JSON.stringify(object));
};

export const checkFileName = (filename: string) => {
  const fileRegex = /[^a-zA-Z0-9-_.]/g;
  let updatedTitle = filename.replace(/ /g, '_').replace(fileRegex, '');
  updatedTitle = updatedTitle.replace(/\.[^/.]+$/, '');

  const maxFileNameLength = 100;
  if (updatedTitle.length > maxFileNameLength) {
    updatedTitle = updatedTitle.substring(0, maxFileNameLength);
  }
  return updatedTitle;
};

export const scriptInjector = ({
  src,
  attach = true,
  body = true,
  module = false
}): HTMLScriptElement => {
  if (!src) {
    GlobalUtils.assert(src == null, 'should not happen');
  }
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  if(module){
    script.type = "module"
  }
  if (attach) {
    body
      ? document.body.appendChild(script)
      : document.head.appendChild(script);
  }
  return script;
};
